'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSendFromResponders = undefined;

var _immutable = require('immutable');

var _getSendFrom = require('./getSendFrom');

var MAX_POTENTIAL_RESPONDERS = 3;

var buildSendFromResponders = exports.buildSendFromResponders = function buildSendFromResponders(widgetData) {
  var sendFrom = (0, _getSendFrom.getSendFrom)(widgetData);
  var hasSendFromResponders = sendFrom && sendFrom.size > 0;
  if (hasSendFromResponders) {
    return sendFrom.take(MAX_POTENTIAL_RESPONDERS);
  }
  return (0, _immutable.List)();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/buildSendFromResponders.js
// module id = 1038
// module chunks = 2 3